module.exports = __webpack_public_path__ + "img/shangyun_logo.0bdf7a81.png";